import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { fetchUsers } from '../../../store/actions/usersActions';
import { updateUser, deleteUser } from '../../../store/actions/usersActions';
import TitlePage from '../../../components/general/TitlePage/TitlePage';
import TableUserPendingForm from '../../../components/intern/TableInform/TableUserPendingForm';
import ConfirmationPopup from '../../../components/intern/ConfirmationPopup/ConfirmationPopup';
import AlertComponent from '../../../components/intern/Alert/Alert'; // Adicione este componente se necessário
import './UserSearchList.css';

const AprovacaoDeAcessosPage = () => {
  const dispatch = useDispatch();
  const [dados, setDados] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [itemsParaExcluir, setItemsParaExcluir] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);
  const users = useSelector((state) => state.users);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    if (users && users.users.length > 0) {
      setDados(users.users.filter(user => !user.approved));
      setLoading(false);
    }
  }, [users]);

  const showAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 5000);
  };

  const handleAprovar = async (selectedUids) => {
    const uids = Array.isArray(selectedUids) ? selectedUids : [selectedUids];

    try {
      // Criar um array de promessas para atualizar todos os usuários selecionados
      const updatePromises = uids.map(uid => {
        const userToUpdate = users.users.find(user => user.uid === uid);

        if (!userToUpdate) {
          console.error(`Usuário com UID ${uid} não encontrado`);
          return Promise.resolve();
        }

        const updatedUser = {
          ...userToUpdate,
          id: userToUpdate.uid,
          selectedGroups: userToUpdate.selectedGroups || [],
          selectedDashboards: userToUpdate.selectedDashboards || [],
          approved: true,
        };

        return dispatch(updateUser(updatedUser)).unwrap();
      });

      // Esperar todas as atualizações serem concluídas
      await Promise.all(updatePromises);

      // Recarregar a lista de usuários
      await dispatch(fetchUsers());

      showAlert('sucesso', `${uids.length > 1 ? 'Usuários aprovados' : 'Usuário aprovado'} com sucesso!`);

    } catch (error) {
      console.error("Erro ao aprovar usuários:", error);
      showAlert('erro', `Erro ao aprovar: ${error.message || 'Tente novamente.'}`);
    }
  };

  const abrirConfirmacaoExclusao = (uids) => {
    setItemsParaExcluir(Array.isArray(uids) ? uids : [uids]);
    setPopupOpen(true);
  };

  const confirmarExclusao = async () => {
    try {
      // Criar um array de promessas para excluir todos os usuários selecionados
      const deletePromises = itemsParaExcluir.map(uid =>
        dispatch(deleteUser(uid)).unwrap()
      );

      // Esperar todas as exclusões serem concluídas
      await Promise.all(deletePromises);

      // Recarregar a lista de usuários
      await dispatch(fetchUsers());

      setPopupOpen(false);
      setItemsParaExcluir([]);
      showAlert('sucesso', `${itemsParaExcluir.length > 1 ? 'Usuários reprovados' : 'Usuário reprovado'} com sucesso!`);

    } catch (error) {
      console.error("Erro ao excluir usuários:", error);
      showAlert('erro', `Erro ao reprovar: ${error.message || 'Tente novamente.'}`);
    }
  };

  return (
    <>
      <section className="container-extern content-with-sidebar">
        <TitlePage
          title="Solicitações de Acesso"
          subtitle="Aprove ou rejeite novas solicitações de acesso com segurança e rastreabilidade."
        />

        <Helmet>
          <title>Access Requests</title>
        </Helmet>

        {alert && <AlertComponent type={alert.type} message={alert.message} onClose={() => setAlert(null)} />}

        {loading ? (
          <p>Carregando usuários...</p>
        ) : dados.length === 0 ? (
          <p className="no-data-message">Nenhuma solicitação de acesso pendente no momento.</p>
        ) : (
          <TableUserPendingForm
            dados={dados}
            onAprovar={handleAprovar}
            onReprovar={abrirConfirmacaoExclusao}
          />
        )}
      </section>

      {popupOpen && (
        <ConfirmationPopup
          onClose={() => setPopupOpen(false)}
          onConfirm={confirmarExclusao}
          title="Confirmar Reprovação"
          message={`Tem certeza que deseja reprovar ${itemsParaExcluir.length > 1 ? 'estes usuários' : 'este usuário'}? Esta ação não pode ser desfeita.`}
        />
      )}
    </>
  );
};

export default AprovacaoDeAcessosPage;